<template>
<div class="chapter">
<div class="inner_page">
      ﻿





<title>Paul Was Not a Christian</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="paulwasnotachristian.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="contents" id="toc">
<a id="page06">
</a><a id="page07">
<h2 class="contentsHead">Contents</h2>
</a><div class="contentsEntry" id="ack_01"><a id="page07">
</a><p class="contentsEntryName1"><a id="page07"></a><a href="#/paulwasnotachristian_ack01#ack01">Acknowledgments</a></p></div>
<div class="contentsEntry" id="fm_01">
<p class="contentsEntryName1"><a href="#/paulwasnotachristian_fm01#fm01">Note to the Reader</a></p></div>
<p class="spaceBreak"> </p>
<div class="contentsEntry" id="fm_02">
<p class="contentsEntryName2"><a href="#/paulwasnotachristian_fm02#fm02">Introduction</a></p></div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/paulwasnotachristian_ch01#ch01">1.</a> Was Paul Really Jewish?</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/paulwasnotachristian_ch02#ch02">2.</a> Paul the Problem</p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/paulwasnotachristian_ch03#ch03">3.</a> How Paul Became a Christian</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch04#ch04" title="Link target outside of Sample">4.</span> Reading Paul as a Jew—Almost</p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch05#ch05" title="Link target outside of Sample">5.</span> Paul’s Jewish Inheritance</p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch06#ch06" title="Link target outside of Sample">6.</span> Who Is and Who Isn’t a Jew?</p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch07#ch07" title="Link target outside of Sample">7.</span> The Flexible Pharisees</p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch08#ch08" title="Link target outside of Sample">8.</span> Paul the (Ex?)-Pharisee</p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch09#ch09" title="Link target outside of Sample">9.</span> A Typical Jew</p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch10#ch10" title="Link target outside of Sample">10.</span> A Radical Jewish Monotheist</p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch11#ch11" title="Link target outside of Sample">11.</span> On a Mission from God</p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch12#ch12" title="Link target outside of Sample">12.</span> “On the Contrary, We Uphold the Law!”</p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch13#ch13" title="Link target outside of Sample">13.</span> Justification Through Jesus Christ</p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/paulwasnotachristian_ch14#ch14" title="Link target outside of Sample">14.</span> It’s the End of the World as We Know It</p></div>
<p class="spaceBreak"> </p>
<div class="contentsEntry" id="bm_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_bm01#bm01" title="Link target outside of Sample">Glossary</span></p></div>
<div class="contentsEntry" id="not_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_not01#not01" title="Link target outside of Sample">Notes</span></p></div>
<div class="contentsEntry" id="bm_02">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_bm02#bm02" title="Link target outside of Sample">Bibliography</span></p></div>
<div class="contentsEntry" id="ind_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_ind01#ind01" title="Link target outside of Sample">Searchable Terms</span></p></div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_ata01#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry" id="cre_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_cre01#cre01" title="Link target outside of Sample">Credits</span></p></div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_cop01#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName1"><span href="#/paulwasnotachristian_atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// paulwasnotachristian_toc.vue?be8a267c